module.exports = __webpack_public_path__ + "img/zavod-blue.b20f9958.jpg";